import React from 'react';
import { FormattedMessage } from 'react-intl';
import ServiceEntryStatus from '../../../data/ServiceEntryStatus';
export default function ServiceEntryStatusComponent(props) {
    var serviceEntryModel = props.serviceEntryModel;
    return React.createElement("div", { className: "d-flex justify-content-start align-items-center" },
        React.createElement("i", { className: 'fe fe-activity mr-3 service-entry-status__icon service-entry-status--' + ServiceEntryStatus.getKeyByValue(serviceEntryModel.calculatedStatus) }),
        React.createElement(FormattedMessage, { id: 'service.entry.status.' + ServiceEntryStatus.getKeyByValue(serviceEntryModel.calculatedStatus) }));
}
